export default __webpack_public_path__ + "static/media/Shadow's Bracers of the Dusk Rebellion.40fb6996.jpg";